// extracted by mini-css-extract-plugin
module.exports = {"imageBackground":"MaskIcon_imageBackground__vjAkn","image":"MaskIcon_image__mf8rq"};